// src/components/common/Loading.jsx
export const Loading = ({ text = "Cargando..." }) => (
  <div style={{
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "40px",
    gap: "16px"
  }}>
    <div style={{
      width: "40px",
      height: "40px",
      border: "4px solid #e2e8f0",
      borderTop: "4px solid #00a680",
      borderRadius: "50%",
      animation: "spin 1s linear infinite"
    }} />
    <p style={{ color: "#64748b", fontSize: "16px", margin: 0 }}>{text}</p>
    <style>{`
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
    `}</style>
  </div>
);